/**
 * Thin client for the admin newsletter endpoints.
 * Mirrors the pattern used by `requestsAdminApi.js` so admins get a
 * consistent feel across the panel.
 */

async function _json(res) {
  let body = null;
  try {
    body = await res.json();
  } catch {
    body = null;
  }
  if (!res.ok) {
    const msg = (body && (body.detail || body.message)) || `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return body;
}

export async function fetchSubscribers({ q = "", limit = 200, skip = 0 } = {}) {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  params.set("limit", String(limit));
  params.set("skip", String(skip));
  const res = await fetch(`/api/admin/newsletter?${params.toString()}`, {
    credentials: "include",
  });
  return _json(res);
}

export async function deleteSubscriber(id) {
  const res = await fetch(`/api/admin/newsletter/${encodeURIComponent(id)}`, {
    method: "DELETE",
    credentials: "include",
  });
  return _json(res);
}

/**
 * Build a CSV download URL that reflects the current admin filters.
 * Returned as a URL (not a fetch result) so the caller can render it
 * on a normal anchor tag — letting the browser stream the file with
 * the cookie auto-attached, instead of buffering the whole file in JS.
 */
export function buildNewsletterCsvExportUrl({ q = "" } = {}) {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  const qs = params.toString();
  return `/api/admin/newsletter/export.csv${qs ? `?${qs}` : ""}`;
}
